import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

export interface BackgroundLabelListParams {
    page?: number;
    pageSize?: number;
    type?: number;
    scope?: number;
    searchTerm?: string;
    category?: string;
}

export interface BackgroundLabelItem {
    id: string;
    name: string;
    s3Url: string;
    s3Key: string;
    uploadedBy: string;
    uploadDate: string;
    type: number;
    scope: number;
    category: string;
    contentType: string;
    fileSize: number;
    displayOrder: number;
}

export interface BackgroundLabelListResponse {
    items: BackgroundLabelItem[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
}

const GetBackgroundLabelList = (params: BackgroundLabelListParams): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.BackgroundLabelQueryURL.GetBackgroundLabelList,
        method: RequestType.GET,
        params,
    });

const GetImageBase64 = (s3Key: string): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.BackgroundLabelQueryURL.GetImageBase64,
        method: RequestType.GET,
        params: { s3Key },
    });

export const BackgroundLabelQuery = {
    GetBackgroundLabelList,
    GetImageBase64,
};

